// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuiviPage_page__8NYZZ {
  width: 100%;
  min-height: calc(100vh - 10rem);
  padding: 1rem;
  box-sizing: border-box;
  background: #f5f8fb;
}

.SuiviPage_card__PsPU4 {
  max-width: 1480px;
  margin: 0 auto;
  overflow: visible;
  border: 1px solid #dce3e8;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(30, 55, 75, .06);
}

.SuiviPage_header__6eLfl {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px 14px;
  border-bottom: 1px solid #e2e8ed;
}

.SuiviPage_header__6eLfl h1 {
  margin: 0;
  color: #173f56;
  font-size: 1.25rem;
  font-weight: 700;
}

.SuiviPage_header__6eLfl p {
  margin: 5px 0 0;
  color: #667783;
  font-size: .84rem;
}

.SuiviPage_total__Jbljk {
  flex: 0 0 auto;
  padding: 6px 10px;
  border-radius: 999px;
  background: #edf4f8;
  color: #2d647e;
  font-size: .78rem;
  font-weight: 600;
}

.SuiviPage_viewTabs__hxUCz {
  display: flex;
  gap: 4px;
  padding: 0 22px;
  border-bottom: 1px solid #e5ebef;
  background: #fff;
}

.SuiviPage_viewTabs__hxUCz button {
  padding: 12px 14px 10px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #667783;
  cursor: pointer;
  font: inherit;
  font-size: .82rem;
  font-weight: 600;
}

.SuiviPage_viewTabs__hxUCz button:hover,
.SuiviPage_viewTabs__hxUCz button:focus-visible {
  color: #173f56;
  outline: none;
}

.SuiviPage_viewTabs__hxUCz .SuiviPage_activeViewTab__O\\+ObX {
  border-bottom-color: #2f6b86;
  color: #173f56;
}

.SuiviPage_filters__GCJfd {
  position: relative;
  z-index: 20;
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr)) auto;
  align-items: end;
  gap: 10px;
  padding: 14px 22px;
  border-bottom: 1px solid #e5ebef;
  background: #f8fafb;
}

.SuiviPage_filters__GCJfd > label,
.SuiviPage_themeFilter__ASsOG {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
  color: #5f6f7b;
  font-size: .73rem;
  font-weight: 600;
}

.SuiviPage_filters__GCJfd select {
  min-height: 38px;
  padding: 7px 10px;
  border: 1px solid #cfd9e0;
  border-radius: 8px;
  background: #fff;
  color: #294252;
  font: inherit;
  font-weight: 400;
}

.SuiviPage_themeFilter__ASsOG {
  position: relative;
}

.SuiviPage_themeMultiSelect__5Quje {
  position: relative;
  color: #294252;
  font-weight: 400;
}

.SuiviPage_themeMultiSelect__5Quje summary {
  min-height: 38px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 30px 7px 10px;
  border: 1px solid #cfd9e0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  list-style: none;
  font-size: .73rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.SuiviPage_themeMultiSelect__5Quje summary::-webkit-details-marker {
  display: none;
}

.SuiviPage_themeMultiSelect__5Quje summary::after {
  content: "⌄";
  position: absolute;
  right: 10px;
  color: #59717f;
  font-size: .9rem;
}

.SuiviPage_themeMultiSelect__5Quje[open] summary {
  border-color: #8fb2c3;
  box-shadow: 0 0 0 2px rgba(47, 107, 134, .08);
}

.SuiviPage_themeOptions__9I107 {
  position: absolute;
  z-index: 40;
  top: calc(100% + 5px);
  left: 0;
  right: 0;
  min-width: 240px;
  max-height: 330px;
  overflow-y: auto;
  padding: 7px;
  border: 1px solid #d4dfe5;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(29, 54, 70, .14);
}

.SuiviPage_themeOptions__9I107 label {
  min-height: 34px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 9px;
  padding: 5px 7px;
  border-radius: 7px;
  color: #294252;
  cursor: pointer;
  font-size: .76rem;
  font-weight: 400;
}

.SuiviPage_themeOptions__9I107 label:hover {
  background: #f1f6f8;
}

.SuiviPage_themeOptions__9I107 input {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  margin: 0;
  accent-color: #2f6b86;
}

.SuiviPage_themeOptions__9I107 .SuiviPage_selectAllTheme__ouYON {
  color: #173f56;
  font-weight: 700;
}

.SuiviPage_themeOptionsSeparator__xi4h4 {
  height: 1px;
  margin: 5px 3px;
  background: #e6ecef;
}

.SuiviPage_clearFilters__QQcfq {
  min-height: 38px;
  padding: 7px 12px;
  border: 1px solid #b8cbd6;
  border-radius: 8px;
  background: #fff;
  color: #2c6079;
  cursor: pointer;
  font-size: .76rem;
  font-weight: 600;
}

.SuiviPage_clearFilters__QQcfq:hover {
  background: #eef6f9;
}

.SuiviPage_tableWrapper__vy5Cp {
  position: relative;
  z-index: 1;
  width: 100%;
  overflow-x: auto;
}

.SuiviPage_table__\\+dt58 {
  width: 100%;
  min-width: 1180px;
  border-collapse: collapse;
  color: #263746;
  font-size: .82rem;
}

.SuiviPage_table__\\+dt58 thead th {
  padding: 11px 12px;
  border-bottom: 1px solid #d9e1e6;
  background: #eef1f3;
  color: #294252;
  text-align: left;
  font-size: .76rem;
  font-weight: 700;
  white-space: nowrap;
}

.SuiviPage_table__\\+dt58 tbody td {
  padding: 12px;
  border-bottom: 1px solid #edf0f2;
  vertical-align: middle;
}

.SuiviPage_table__\\+dt58 tbody tr:last-child td {
  border-bottom: 0;
}

.SuiviPage_table__\\+dt58 tbody tr:hover {
  background: #f8fbfd;
}

.SuiviPage_status__0aQmE {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 78px;
  padding: 5px 8px;
  border: 1px solid currentColor;
  border-radius: 999px;
  font-size: .72rem;
  font-weight: 700;
  white-space: nowrap;
}

.SuiviPage_statusRequest__tER0e {
  color: #d45a5a;
  background: #fff0f0;
}

.SuiviPage_statusProposal__yWnik {
  color: #d36e8f;
  background: #fff1f6;
}

.SuiviPage_statusScheduled__vI2Hz {
  color: #b7771e;
  background: #fff7df;
}

.SuiviPage_statusCompleted__pwLUX {
  color: #2f8b5d;
  background: #eaf7f0;
}

.SuiviPage_values__UDmG5 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  min-width: 72px;
}

.SuiviPage_valueIcon__2mvhZ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border: 1px solid currentColor;
  border-radius: 6px;
  background: #fff;
}

.SuiviPage_valueIcon__2mvhZ img {
  width: 16px;
  height: 16px;
}

.SuiviPage_bienveillance__BLKeD {
  color: var(--upcare-value-bienveillance);
  background: var(--upcare-value-bienveillance-soft);
}

.SuiviPage_engagement__iJfBP {
  color: var(--upcare-value-engagement);
  background: var(--upcare-value-engagement-soft);
}

.SuiviPage_faireEquipe__xe7OE {
  color: var(--upcare-value-faire-equipe);
  background: var(--upcare-value-faire-equipe-soft);
}

.SuiviPage_respect__Lmfet {
  color: var(--upcare-value-respect);
  background: var(--upcare-value-respect-soft);
}

.SuiviPage_theme__E7rg3 {
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 999px;
  background: #eaf5f9;
  color: #245b72;
  font-size: .72rem;
  font-weight: 600;
  white-space: nowrap;
}

.SuiviPage_titleCell__WNuse {
  min-width: 210px;
  color: #172d3b;
  font-weight: 600;
}

.SuiviPage_noData__2fUZf {
  color: #87939b;
}

.SuiviPage_state__mLgj4,
.SuiviPage_error__qCgVe {
  margin: 18px;
  padding: 28px 18px;
  border-radius: 10px;
  background: #f8fafb;
  color: #687782;
  text-align: center;
}

.SuiviPage_error__qCgVe {
  color: #b42318;
  background: #fff5f4;
}

@media (max-width: 1050px) {
  .SuiviPage_filters__GCJfd {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }
}

@media (max-width: 760px) {
  .SuiviPage_page__8NYZZ {
    padding: .75rem;
  }

  .SuiviPage_header__6eLfl {
    flex-direction: column;
  }

  .SuiviPage_viewTabs__hxUCz {
    padding: 0 16px;
  }

  .SuiviPage_filters__GCJfd {
    grid-template-columns: 1fr;
    padding: 12px 16px;
  }

  .SuiviPage_themeOptions__9I107 {
    min-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ValeurPage/SuiviPage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yDAAyD;EACzD,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".page {\n  width: 100%;\n  min-height: calc(100vh - 10rem);\n  padding: 1rem;\n  box-sizing: border-box;\n  background: #f5f8fb;\n}\n\n.card {\n  max-width: 1480px;\n  margin: 0 auto;\n  overflow: visible;\n  border: 1px solid #dce3e8;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(30, 55, 75, .06);\n}\n\n.header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 20px 22px 14px;\n  border-bottom: 1px solid #e2e8ed;\n}\n\n.header h1 {\n  margin: 0;\n  color: #173f56;\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n\n.header p {\n  margin: 5px 0 0;\n  color: #667783;\n  font-size: .84rem;\n}\n\n.total {\n  flex: 0 0 auto;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: #edf4f8;\n  color: #2d647e;\n  font-size: .78rem;\n  font-weight: 600;\n}\n\n.viewTabs {\n  display: flex;\n  gap: 4px;\n  padding: 0 22px;\n  border-bottom: 1px solid #e5ebef;\n  background: #fff;\n}\n\n.viewTabs button {\n  padding: 12px 14px 10px;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  background: transparent;\n  color: #667783;\n  cursor: pointer;\n  font: inherit;\n  font-size: .82rem;\n  font-weight: 600;\n}\n\n.viewTabs button:hover,\n.viewTabs button:focus-visible {\n  color: #173f56;\n  outline: none;\n}\n\n.viewTabs .activeViewTab {\n  border-bottom-color: #2f6b86;\n  color: #173f56;\n}\n\n.filters {\n  position: relative;\n  z-index: 20;\n  display: grid;\n  grid-template-columns: repeat(4, minmax(150px, 1fr)) auto;\n  align-items: end;\n  gap: 10px;\n  padding: 14px 22px;\n  border-bottom: 1px solid #e5ebef;\n  background: #f8fafb;\n}\n\n.filters > label,\n.themeFilter {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 5px;\n  color: #5f6f7b;\n  font-size: .73rem;\n  font-weight: 600;\n}\n\n.filters select {\n  min-height: 38px;\n  padding: 7px 10px;\n  border: 1px solid #cfd9e0;\n  border-radius: 8px;\n  background: #fff;\n  color: #294252;\n  font: inherit;\n  font-weight: 400;\n}\n\n.themeFilter {\n  position: relative;\n}\n\n.themeMultiSelect {\n  position: relative;\n  color: #294252;\n  font-weight: 400;\n}\n\n.themeMultiSelect summary {\n  min-height: 38px;\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 7px 30px 7px 10px;\n  border: 1px solid #cfd9e0;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  list-style: none;\n  font-size: .73rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.themeMultiSelect summary::-webkit-details-marker {\n  display: none;\n}\n\n.themeMultiSelect summary::after {\n  content: \"⌄\";\n  position: absolute;\n  right: 10px;\n  color: #59717f;\n  font-size: .9rem;\n}\n\n.themeMultiSelect[open] summary {\n  border-color: #8fb2c3;\n  box-shadow: 0 0 0 2px rgba(47, 107, 134, .08);\n}\n\n.themeOptions {\n  position: absolute;\n  z-index: 40;\n  top: calc(100% + 5px);\n  left: 0;\n  right: 0;\n  min-width: 240px;\n  max-height: 330px;\n  overflow-y: auto;\n  padding: 7px;\n  border: 1px solid #d4dfe5;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 10px 24px rgba(29, 54, 70, .14);\n}\n\n.themeOptions label {\n  min-height: 34px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 9px;\n  padding: 5px 7px;\n  border-radius: 7px;\n  color: #294252;\n  cursor: pointer;\n  font-size: .76rem;\n  font-weight: 400;\n}\n\n.themeOptions label:hover {\n  background: #f1f6f8;\n}\n\n.themeOptions input {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 auto;\n  margin: 0;\n  accent-color: #2f6b86;\n}\n\n.themeOptions .selectAllTheme {\n  color: #173f56;\n  font-weight: 700;\n}\n\n.themeOptionsSeparator {\n  height: 1px;\n  margin: 5px 3px;\n  background: #e6ecef;\n}\n\n.clearFilters {\n  min-height: 38px;\n  padding: 7px 12px;\n  border: 1px solid #b8cbd6;\n  border-radius: 8px;\n  background: #fff;\n  color: #2c6079;\n  cursor: pointer;\n  font-size: .76rem;\n  font-weight: 600;\n}\n\n.clearFilters:hover {\n  background: #eef6f9;\n}\n\n.tableWrapper {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  min-width: 1180px;\n  border-collapse: collapse;\n  color: #263746;\n  font-size: .82rem;\n}\n\n.table thead th {\n  padding: 11px 12px;\n  border-bottom: 1px solid #d9e1e6;\n  background: #eef1f3;\n  color: #294252;\n  text-align: left;\n  font-size: .76rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.table tbody td {\n  padding: 12px;\n  border-bottom: 1px solid #edf0f2;\n  vertical-align: middle;\n}\n\n.table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.table tbody tr:hover {\n  background: #f8fbfd;\n}\n\n.status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 78px;\n  padding: 5px 8px;\n  border: 1px solid currentColor;\n  border-radius: 999px;\n  font-size: .72rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.statusRequest {\n  color: #d45a5a;\n  background: #fff0f0;\n}\n\n.statusProposal {\n  color: #d36e8f;\n  background: #fff1f6;\n}\n\n.statusScheduled {\n  color: #b7771e;\n  background: #fff7df;\n}\n\n.statusCompleted {\n  color: #2f8b5d;\n  background: #eaf7f0;\n}\n\n.values {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 5px;\n  min-width: 72px;\n}\n\n.valueIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 25px;\n  height: 25px;\n  border: 1px solid currentColor;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.valueIcon img {\n  width: 16px;\n  height: 16px;\n}\n\n.bienveillance {\n  color: var(--upcare-value-bienveillance);\n  background: var(--upcare-value-bienveillance-soft);\n}\n\n.engagement {\n  color: var(--upcare-value-engagement);\n  background: var(--upcare-value-engagement-soft);\n}\n\n.faireEquipe {\n  color: var(--upcare-value-faire-equipe);\n  background: var(--upcare-value-faire-equipe-soft);\n}\n\n.respect {\n  color: var(--upcare-value-respect);\n  background: var(--upcare-value-respect-soft);\n}\n\n.theme {\n  display: inline-flex;\n  padding: 4px 8px;\n  border-radius: 999px;\n  background: #eaf5f9;\n  color: #245b72;\n  font-size: .72rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.titleCell {\n  min-width: 210px;\n  color: #172d3b;\n  font-weight: 600;\n}\n\n.noData {\n  color: #87939b;\n}\n\n.state,\n.error {\n  margin: 18px;\n  padding: 28px 18px;\n  border-radius: 10px;\n  background: #f8fafb;\n  color: #687782;\n  text-align: center;\n}\n\n.error {\n  color: #b42318;\n  background: #fff5f4;\n}\n\n@media (max-width: 1050px) {\n  .filters {\n    grid-template-columns: repeat(2, minmax(180px, 1fr));\n  }\n}\n\n@media (max-width: 760px) {\n  .page {\n    padding: .75rem;\n  }\n\n  .header {\n    flex-direction: column;\n  }\n\n  .viewTabs {\n    padding: 0 16px;\n  }\n\n  .filters {\n    grid-template-columns: 1fr;\n    padding: 12px 16px;\n  }\n\n  .themeOptions {\n    min-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `SuiviPage_page__8NYZZ`,
	"card": `SuiviPage_card__PsPU4`,
	"header": `SuiviPage_header__6eLfl`,
	"total": `SuiviPage_total__Jbljk`,
	"viewTabs": `SuiviPage_viewTabs__hxUCz`,
	"activeViewTab": `SuiviPage_activeViewTab__O+ObX`,
	"filters": `SuiviPage_filters__GCJfd`,
	"themeFilter": `SuiviPage_themeFilter__ASsOG`,
	"themeMultiSelect": `SuiviPage_themeMultiSelect__5Quje`,
	"themeOptions": `SuiviPage_themeOptions__9I107`,
	"selectAllTheme": `SuiviPage_selectAllTheme__ouYON`,
	"themeOptionsSeparator": `SuiviPage_themeOptionsSeparator__xi4h4`,
	"clearFilters": `SuiviPage_clearFilters__QQcfq`,
	"tableWrapper": `SuiviPage_tableWrapper__vy5Cp`,
	"table": `SuiviPage_table__+dt58`,
	"status": `SuiviPage_status__0aQmE`,
	"statusRequest": `SuiviPage_statusRequest__tER0e`,
	"statusProposal": `SuiviPage_statusProposal__yWnik`,
	"statusScheduled": `SuiviPage_statusScheduled__vI2Hz`,
	"statusCompleted": `SuiviPage_statusCompleted__pwLUX`,
	"values": `SuiviPage_values__UDmG5`,
	"valueIcon": `SuiviPage_valueIcon__2mvhZ`,
	"bienveillance": `SuiviPage_bienveillance__BLKeD`,
	"engagement": `SuiviPage_engagement__iJfBP`,
	"faireEquipe": `SuiviPage_faireEquipe__xe7OE`,
	"respect": `SuiviPage_respect__Lmfet`,
	"theme": `SuiviPage_theme__E7rg3`,
	"titleCell": `SuiviPage_titleCell__WNuse`,
	"noData": `SuiviPage_noData__2fUZf`,
	"state": `SuiviPage_state__mLgj4`,
	"error": `SuiviPage_error__qCgVe`
};
export default ___CSS_LOADER_EXPORT___;
